
























import { ValidationObserver } from 'vee-validate';

export default {
  name: 'SendNotificationModal',
  props: {
    attendedCount: {
      default: null,
      type: Number,
    },
    registerWithAttendedNumber: {
      default: null,
      type: Number,
    },
  },
  data() {
    return {
      excludeUnattended: false,
    };
  },
  computed: {
    count() {
      return this.excludeUnattended
        ? this.attendedCount
        : this.registerWithAttendedNumber;
    },
  },
  methods: {
    submit() {
      this.$parent.$emit('submit', this.excludeUnattended);
      this.$emit('close');
    },
  },
};
